import { useNavigationEventBus as i } from "@ado/acs-standard-library";
import { submitInternalEvent as a } from "@ado/tracking-library";
const s = "_self";
function E(t, n, e) {
  a(t);
  const { url: o, target: r = s } = n;
  (e ?? i()).navigate(o, r);
}
export {
  E as submitInternalEventAndRedirectToPage
};
//# sourceMappingURL=index.js.map
